import script from "./DiceRollerView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiceRollerView.vue?vue&type=script&setup=true&lang=js"

import "./DiceRollerView.vue?vue&type=style&index=0&id=2a6b9a42&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6b9a42"]])

export default __exports__